module.exports = __webpack_public_path__ + "static/img/home_img_figure.b0af9bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/home_img_figure.png
// module id = +TEt
// module chunks = 0